import { createSlice } from "@reduxjs/toolkit";

import { ScoreState } from "@/types/score";

import { RootState } from "@/redux";

import { scoreApi } from "./score.api";

const initialState: ScoreState = {
	score: null,
	companyCategoryResultHistory: null,
	personaCategoryResultHistory: null,
	scoringHistory: null,
	scoreCriteria: null,
};

export const scoreSlice = createSlice({
	name: "score",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(scoreApi.endpoints.getScore.matchFulfilled, (state, { payload }) => {
			state.score = payload;
		});
		builder.addMatcher(scoreApi.endpoints.updateScore.matchFulfilled, (state, { payload }) => {
			state.score = payload;
		});
		builder.addMatcher(
			scoreApi.endpoints.getCompanyCategoryResultHistory.matchFulfilled,
			(state, { payload }) => {
				state.companyCategoryResultHistory = payload;
			}
		);
		builder.addMatcher(
			scoreApi.endpoints.getPersonaCategoryResultHistory.matchFulfilled,
			(state, { payload }) => {
				state.personaCategoryResultHistory = payload;
			}
		);
		builder.addMatcher(
			scoreApi.endpoints.getScoringHistory.matchFulfilled,
			(state, { payload }) => {
				state.scoringHistory = payload;
			}
		);
		builder.addMatcher(scoreApi.endpoints.getScoreCriteria.matchFulfilled, (state, { payload }) => {
			state.scoreCriteria = payload;
		});
	},
});

export const scoreReducer = scoreSlice.reducer;
export const scoreSelector = (state: RootState) => state[scoreSlice.name];
export const criteriaSelector = (state: RootState) =>
	scoreSelector(state).scoreCriteria?.allCriteria ?? [];
